export default __webpack_public_path__ + "static/media/email.08d6167f.png";